import React from "react";
import "../../styleSheets/blockingPageLoader.css";
import "../../styleSheets/buttons.css";

type BlockingPageLoaderProps = {
  message: string;
  isError?: boolean;
  retryLabel?: string;
  exitLabel?: string;
  onRetry?: () => void;
  onExit?: () => void;
};

function BlockingPageLoader({
  message,
  isError = false,
  retryLabel,
  exitLabel,
  onRetry,
  onExit,
}: BlockingPageLoaderProps) {
  return (
    <div
      className="blocking-page-loader"
      role={isError ? "alert" : "status"}
      aria-live={isError ? "assertive" : "polite"}
      aria-busy={!isError}
    >
      <div className="blocking-page-loader__card">
        {isError ? (
          <div
            className="blocking-page-loader__error-indicator"
            aria-hidden="true"
          />
        ) : (
          <div className="blocking-page-loader__spinner" aria-hidden="true" />
        )}
        <div className="blocking-page-loader__message">{message}</div>
        {isError && (onRetry || onExit) ? (
          <div className="blocking-page-loader__actions">
            {onExit ? (
              <button
                type="button"
                className="btn btn--gray btn--size-md"
                onClick={onExit}
              >
                {exitLabel}
              </button>
            ) : null}
            {onRetry ? (
              <button
                type="button"
                className="btn btn--green btn--size-md"
                onClick={onRetry}
              >
                {retryLabel}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default BlockingPageLoader;
